const TableSlot = (props: TypeObject): any => {
  const params = {
    row: props.row,
    $index: props.index,
    column: props.column || null,
    store: props.store || null,
    _self: props._self || null,
  };

  return props.render(params);
};

TableSlot.props = {
  row: {
    type: Object,
    default: null,
  },
  render: {
    type: Function,
    default: null,
  },
  index: {
    type: Number,
    default: -1,
  },
  column: {
    type: Object,
    default: null,
  },
  store: {
    type: Object,
    default: null,
  },
  _self: {
    type: Object,
    default: null,
  },
};

export default TableSlot;
